// extracted by css-extract-rspack-plugin
export default {"description":"_494b13a"};